import { QueryParams } from 'APIs/types';
import getFetchOptions from 'utils/getFetchOptions';

import { PaginatedResponse, handlePaginatedResponse, toQueryString } from '../utils';
import { EnterprisesResponse } from './enterprises.types';

export const getEnterprises = async (
  apiAprilBaseUri: string,
  queryParams: QueryParams,
): Promise<PaginatedResponse<EnterprisesResponse>> => {
  const qParams = toQueryString(queryParams, ['readableIdentifier']);
  const options = await getFetchOptions('GET');

  return await fetch(`${apiAprilBaseUri}/enterprises${qParams}`, options).then(handlePaginatedResponse);
};
